import { css } from 'lit';
         export default css` 
         @charset "UTF-8";
/* ------------------------------------*\
    #BREAKPOINT VARIABLES
\*------------------------------------ */
/* ------------------------------------*\
    #TYPOGRAPHY APPLICATIONS
\*------------------------------------ */
/**
   * Visible focus outline 2px inside the element on a light background
   */
/**
   * Visible focus outline 2px inside the element on a dark background
   */
/**
   * Visible focus outline for elements on a light background
   */
/**
   * Invisible focus outline for elements that need a more visible
   * focus state for high-contrast mode
   */
/**
   * Visually hidden from display
   */
/**
   * style for text ellipsis
   */
/**
   * Popover attribute has default styling which comes from UA stylesheets which will be overridden here.
   */
/* ------------------------------------*\
    #VISIBILITY UTILITIES
\*------------------------------------ */
/* Completely remove from the flow and screen readers. */
.cat-u-is-hidden {
  display: none !important;
  visibility: hidden !important;
}

/* Completely remove from the flow but leave available to screen readers. */
.cat-u-is-vishidden {
  position: absolute !important;
  overflow: hidden;
  width: 1px;
  height: 1px;
  padding: 0;
  border: 0;
  clip: rect(1px, 1px, 1px, 1px);
}

/**
 * Hide element at sm breakpoint 
 */
@media all and (min-width: 23.4375rem) {
  .cat-u-hide-sm {
    display: none !important;
  }
}

/**
 * Hide element at sm-2 breakpoint 
 */
@media all and (min-width: 35rem) {
  .cat-u-hide-sm-2 {
    display: none !important;
  }
}

/**
 * Hide element at md breakpoint 
 */
@media all and (min-width: 48rem) {
  .cat-u-hide-md {
    display: none !important;
  }
}

/**
 * Hide element at lg breakpoint 
 */
@media all and (min-width: 60rem) {
  .cat-u-hide-lg {
    display: none !important;
  }
}

/**
 * Hide element at xl breakpoint 
 */
@media all and (min-width: 75rem) {
  .cat-u-hide-xl {
    display: none !important;
  }
}

/**
 * Show element at sm breakpoint 
 */
@media all and (max-width: 23.4375rem) {
  .cat-u-show-sm {
    display: none !important;
  }
}

/**
 * Show element at sm-2 breakpoint 
 */
@media all and (max-width: 35rem) {
  .cat-u-show-sm-2 {
    display: none !important;
  }
}

/**
 * Show element at md breakpoint 
 */
@media all and (max-width: 48rem) {
  .cat-u-show-md {
    display: none !important;
  }
}

/**
 * Show element at lg breakpoint 
 */
@media all and (max-width: 60rem) {
  .cat-u-show-lg {
    display: none !important;
  }
}

/**
 * Show element at xl breakpoint 
 */
@media all and (max-width: 75rem) {
  .cat-u-show-xl {
    display: none !important;
  }
}

/* ------------------------------------*\
    #RESET
\*------------------------------------ */
/**
 * Border-Box http:/paulirish.com/2012/box-sizing-border-box-ftw/
 */
*,
::slotted(*),
*:before,
*:after {
  box-sizing: border-box;
}

:focus-visible {
  outline-color: var(--cat-theme-color-focus-ring);
}

/* ------------------------------------*\
 #DROPDOWN
\*------------------------------------ */
:host {
  width: 100%;
}

[popover] {
  position: unset;
  inset: unset;
  width: unset;
  height: unset;
  margin: unset;
  border: unset;
  padding: unset;
  color: unset;
  background-color: unset;
  overflow: unset;
}

/**
 * Dropdown
 */
.cat-c-dropdown {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  --cat-dropdown-padding-vert-top: calc(var(--size-base-unit) * 0.875);
  --cat-dropdown-padding-vert-bottom: calc(var(--size-base-unit) * 0.875);
  --cat-dropdown-padding-horiz: var(--cat-space-small);
  --cat-dropdown-padding-horiz-end: var(--cat-space-2x-large);
  --cat-dropdown-checkbox-padding: calc(var(--size-base-unit) * 1.75) var(--cat-space-x-small) calc(var(--size-base-unit) * 1.75) var(--cat-space-3x-large);
  --cat-dropdown-checkbox-padding-left: var(--cat-space-3x-large);
  --cat-dropdown-checkbox-input-padding: calc(var(--size-base-unit) * 1.75);
  --cat-dropdown-cross-icon-padding: calc(var(--size-base-unit) * 0.125) calc(var(--size-base-unit) * 0.875);
  --cat-dropdown-checkbox-checked-background: var(--cat-theme-color-background-subtle);
  --cat-dropdown-panel-transform: calc(var(--size-base-unit) * 0.1);
}

/**
* Stles for numeric input container
*/
.cat-c-dropdown__container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
}

/**
 * Dropdown body
 */
.cat-c-dropdown__body {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: calc(var(--size-base-unit) * 0.25);
  padding-block: var(--cat-space-x-small);
  width: 100%;
  padding: var(--cat-dropdown-padding-vert-top) var(--cat-dropdown-padding-horiz) var(--cat-dropdown-padding-vert-bottom);
  border-radius: calc(var(--size-base-unit) * 0.5);
  border: calc(var(--size-base-unit) * 0.125) solid var(--cat-theme-color-form-border);
  cursor: pointer;
  background-color: var(--cat-theme-color-background-default);
  /**
   * If the dropdown is medium, then padding top,bottom and hoizontal
   */
  /**
   * If the dropdown is small, then padding top,bottom and hoizontal
   */
  /**
   * If the dropdown is readonly
   */
}
.cat-c-dropdown__body input::-webkit-outer-spin-button,
.cat-c-dropdown__body input::-webkit-inner-spin-button {
  display: none;
}
.cat-c-dropdown__body:hover:not(:disabled) {
  border: calc(var(--size-base-unit) * 0.125) solid var(--cat-theme-color-form-border-hover);
  background: var(--cat-theme-color-form-background-hover);
}
.cat-is-readonly .cat-c-dropdown__body:hover:not(:disabled) {
  background: var(--cat-theme-color-form-background);
}
.cat-c-dropdown__body:focus-within, .cat-c-dropdown__body:focus, .cat-c-dropdown__body:focus-visible {
  background: var(--cat-theme-color-form-background);
}
.cat-c-dropdown .cat-c-dropdown__body:focus-within, .cat-c-dropdown .cat-c-dropdown__body:focus, .cat-c-dropdown .cat-c-dropdown__body:focus-visible {
  outline: 2px solid var(--cat-theme-color-focus-ring);
  outline-offset: var(--cat-theme-offset-focus-ring, 2px);
  transition: all var(--cat-anim-fade-quick) var(--cat-anim-ease);
}
.cat-c-dropdown__body:not(:placeholder-shown):focus:not(:disabled, :read-only) {
  outline: 2px solid var(--cat-theme-color-focus-ring);
  outline-offset: var(--cat-theme-offset-focus-ring, 2px);
  transition: all var(--cat-anim-fade-quick) var(--cat-anim-ease);
}
.cat-c-dropdown__body:active:not(:disabled) {
  background: var(--cat-theme-color-form-background-hover);
}
.cat-c-dropdown--medium .cat-c-dropdown__body {
  --cat-dropdown-padding-vert-top: calc(var(--size-base-unit) * 0.875);
  --cat-dropdown-padding-vert-bottom: calc(var(--size-base-unit) * 0.875);
  --cat-dropdown-padding-horiz: var(--cat-space-small);
  padding: var(--cat-dropdown-padding-vert-top) var(--cat-dropdown-padding-horiz) var(--cat-dropdown-padding-vert-bottom);
}
.cat-c-dropdown--small .cat-c-dropdown__body {
  --cat-dropdown-padding-vert-top: calc(var(--size-base-unit) * 0.375);
  --cat-dropdown-padding-vert-bottom: calc(var(--size-base-unit) * 0.375);
  --cat-dropdown-padding-horiz: var(--cat-space-x-small);
  padding: var(--cat-dropdown-padding-vert-top) var(--cat-dropdown-padding-horiz) var(--cat-dropdown-padding-vert-bottom);
}
.cat-c-dropdown.cat-is-readonly .cat-c-dropdown__body {
  border: 1px solid var(--cat-theme-color-border-readonly);
  pointer-events: none;
}
.cat-c-dropdown.cat-is-readonly .cat-c-dropdown__body:focus-within, .cat-c-dropdown.cat-is-readonly .cat-c-dropdown__body:focus {
  outline: 2px solid var(--cat-theme-color-focus-ring);
  outline-offset: var(--cat-theme-offset-focus-ring, 2px);
  transition: all var(--cat-anim-fade-quick) var(--cat-anim-ease);
  background: var(--cat-theme-color-form-background);
}
.cat-is-error .cat-c-dropdown__body {
  --cat-dropdown-padding-vert-top: var(--cat-space-2x-small);
  --cat-dropdown-padding-vert-bottom: var(--cat-space-2x-small);
}
.cat-is-typeahead .cat-c-dropdown__body:hover {
  cursor: text;
}

/**
 * Dropdown label
 */
.cat-c-dropdown__label {
  font-family: var(--cat-theme-typography-label-sm-font-family);
  font-weight: var(--cat-theme-typography-label-sm-font-weight);
  font-size: var(--cat-theme-typography-label-sm-font-size);
  line-height: var(--cat-theme-typography-label-sm-line-height);
  display: flex;
  gap: var(--cat-space-3x-small);
  flex: 1 0 0;
  max-width: 100%;
  word-wrap: break-word;
  /**
   * required label
  **/
  /**
   * If the dropdown is disabled, change the color of the label
   */
  /**
  * Label in medium size
  */
  /**
   * If the dropdown label is hidden, visually hide the label
   */
  /**
   * Label in readonly
   */
}
.cat-c-dropdown__label .cat-c-dropdown__notation-label {
  padding-inline-start: var(--cat-space-3x-small);
  color: var(--cat-theme-color-content-subtle);
  font-weight: var(--cat-font-weight-regular);
}
.cat-c-dropdown--disabled .cat-c-dropdown__label {
  color: var(--cat-theme-color-content-disabled);
  pointer-events: none;
}
.cat-c-dropdown--disabled .cat-c-dropdown__label:hover {
  cursor: not-allowed;
}
.cat-c-dropdown--medium .cat-c-dropdown__label, .cat-c-dropdown--large .cat-c-dropdown__label {
  position: static;
  margin-block-end: var(--cat-space-x-small);
}
.cat-c-dropdown--large .cat-c-dropdown__label {
  display: inline-flex;
}
.cat-c-dropdown--small .cat-c-dropdown__label {
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}
.cat-hidden-label .cat-c-dropdown__label {
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}
.cat-is-readonly .cat-c-dropdown__label {
  pointer-events: none;
}

/**
* If the dropdown is disabled, change the color of the required Label
*/
.cat-c-dropdown--disabled .cat-c-dropdown__notation {
  color: var(--cat-theme-color-content-disabled);
}

.cat-hidden-label:not(.cat-c-dropdown--medium, .cat-c-dropdown--ghost, .cat-c-dropdown--small) .cat-c-dropdown__select {
  padding-block: calc(var(--size-base-unit) * 0.75);
}

/**
 * Dropdown input wrap
 * 1) The input wrap is positioned relative, so the inner items are positioned properly
 * 2) The wrapper for the input, value, and icons
 */
.cat-c-dropdown__input-wrap {
  display: flex;
  align-items: center;
  gap: var(--cat-space-x-small);
  flex: 1 0 0;
  align-self: stretch;
  /**
   * If the drowdown isDynamicWidth true, set the width of the input wrap based on the value
   */
}
.cat-c-dropdown--large .cat-c-dropdown__input-wrap {
  padding-block: var(--cat-space-3x-small);
}
.cat-is-dynamic-width .cat-c-dropdown__input-wrap {
  width: var(--cat-dropdown-width);
}

/**
 * Dropdown select 
 */
.cat-c-dropdown__select {
  font-family: var(--cat-theme-typography-body-font-family);
  font-weight: var(--cat-theme-typography-body-font-weight);
  font-size: var(--cat-theme-typography-body-font-size);
  line-height: var(--cat-theme-typography-body-line-height);
  order: 3;
  width: 100%;
  flex: 1 0 0;
  overflow: hidden;
  text-overflow: ellipsis;
  border: none;
  line-height: var(--cat-line-height-default, var(--cat-line-height-24));
  font-size: var(--cat-font-size-default, var(--cat-font-size-16));
  padding: 0;
  background: var(--component-form-form-background-hover);
  box-shadow: none;
  cursor: pointer;
  caret-color: transparent;
}
.cat-c-dropdown__select.cat-c-dropdown__select-only {
  min-height: calc(var(--size-base-unit) * 3);
}
.cat-c-dropdown__select::placeholder {
  font-family: var(--cat-theme-typography-body-font-family);
  font-weight: var(--cat-theme-typography-body-font-weight);
  font-size: var(--cat-theme-typography-body-font-size);
  line-height: var(--cat-theme-typography-body-line-height);
  color: var(--cat-theme-color-content-subtle);
}
.cat-c-dropdown--disabled .cat-c-dropdown__select::placeholder {
  color: var(--cat-theme-color-content-disabled);
}
.cat-is-error .cat-c-dropdown__select::placeholder, .cat-is-warning .cat-c-dropdown__select::placeholder, .cat-is-readonly:not(.cat-c-dropdown--disabled) .cat-c-dropdown__select::placeholder {
  color: var(--cat-theme-color-content-default);
}
.cat-c-dropdown__select:not(:placeholder-shown):focus:not(.cat-is-error, :disabled, :read-only) {
  box-shadow: none;
}
.cat-c-dropdown__select:focus {
  outline: none;
  border: none;
}
.cat-c-dropdown__select:hover:not(:focus, :focus-within, :disabled) {
  background: var(--component-form-form-background-hover);
}

.cat-is-active .cat-c-dropdown__body,
.cat-is-error.cat-is-active .cat-c-dropdown__body {
  border: 1px solid var(--cat-theme-color-form-border-active);
  background: var(--cat-theme-color-form-background-hover);
}
.cat-is-active .cat-c-dropdown__body:focus-within,
.cat-is-error.cat-is-active .cat-c-dropdown__body:focus-within {
  border: 1px solid var(--cat-theme-color-form-border-active);
}

.cat-c-dropdown__select:focus .cat-c-dropdown__body {
  outline: calc(var(--size-base-unit) * 0.25) solid var(--cat-theme-color-form-border-focus);
  outline-offset: calc(var(--size-base-unit) * -0.25);
  background: var(--cat-theme-color-form-background);
}

/**
* Background style for input box on hover the container
*/
.cat-c-dropdown__body:hover:not(:focus, :focus-within, :disabled, :active) .cat-c-dropdown__select {
  background: var(--cat-theme-color-form-background-hover);
}
.cat-is-readonly .cat-c-dropdown__body:hover:not(:focus, :focus-within, :disabled, :active) .cat-c-dropdown__select {
  background: var(--cat-theme-color-form-background);
}

.cat-c-dropdown__cross-icon-size {
  --cat-icon-height: calc(var(--size-base-unit) * 1.5);
  --cat-icon-width: calc(var(--size-base-unit) * 1.5);
}

/**
 * Dropdown with large size
 */
.cat-c-dropdown--large {
  --cat-dropdown-checkbox-padding: var(--cat-space-small) var(--cat-space-x-small) var(--cat-space-small) var(--cat-space-3x-large);
  --cat-dropdown-checkbox-input-padding: var(--cat-space-small);
}

/**
 * Dropdown with medium size
 */
.cat-c-dropdown--medium {
  --cat-dropdown-checkbox-padding: var(--cat-space-2x-small) var(--cat-space-x-small) var(--cat-space-2x-small) var(--cat-space-3x-large);
  --cat-dropdown-checkbox-input-padding: var(--cat-space-3x-small);
}
.cat-c-dropdown--medium .cat-c-textarea-field--label {
  word-wrap: break-word;
  max-width: 100%;
}

/**
 * Dropdown with small size
 */
.cat-c-dropdown--small {
  --cat-dropdown-checkbox-padding: var(--cat-space-2x-small) var(--cat-space-3x-large);
  --cat-dropdown-checkbox-input-padding: var(--cat-space-3x-small);
}

/**
 * Active styles for dropdown select
 */
.cat-c-dropdown__select:not(:disabled) {
  caret-color: auto;
}
.cat-c-dropdown.cat-is-active .cat-c-dropdown__select:not(:disabled) {
  outline: none;
  box-shadow: none;
}
.cat-c-dropdown.cat-is-typeahead .cat-c-dropdown__select:not(:disabled):hover {
  cursor: text;
}
.cat-c-dropdown.cat-is-typeahead .cat-c-dropdown__select:not(:disabled):focus:not(:disabled, :read-only)::placeholder {
  color: transparent;
}

/**
 * Active styles for dropdown value
 */
.cat-c-dropdown.cat-is-active .cat-c-dropdown__before-icon {
  color: var(--cat-theme-color-content-strong);
}

/**
 * Dropdown disabled
 */
.cat-c-dropdown--disabled {
  cursor: not-allowed;
}
.cat-c-dropdown--disabled .cat-c-dropdown__select {
  pointer-events: none;
  color: var(--cat-theme-color-content-disabled);
}
.cat-c-dropdown--disabled .cat-c-dropdown__body {
  pointer-events: none;
  border: 1px solid var(--cat-theme-color-border-disabled);
  background: var(--cat-theme-color-background-default-disabled);
  color: var(--cat-theme-color-content-disabled);
}

.cat-c-textarea-field--label {
  color: var(--cat-theme-color-content-default);
  /**
   * Hide label
   */
}
.cat-c-numeric-input--hidden-label .cat-c-textarea-field--label {
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}
.cat-c-dropdown--disabled .cat-c-textarea-field--label {
  color: var(--cat-theme-color-content-disabled);
  pointer-events: none;
}
.cat-c-dropdown--disabled .cat-c-textarea-field--label:hover {
  cursor: not-allowed;
}

.cat-is-error .cat-c-dropdown__body:hover:not(:focus, :focus-within, :disabled, :active) {
  outline: calc(var(--size-base-unit) * 0.25) solid var(--cat-theme-color-content-utility-error);
  outline-offset: calc(var(--size-base-unit) * -0.25);
  background: var(--cat-theme-color-form-background-hover);
}
.cat-is-error .cat-c-dropdown__body:not(:placeholder-shown):focus:not(:disabled, :read-only) {
  box-shadow: none;
}

/**
* Cross icon should not be visible for readonly state, when the dropdown is not active
*/
.cat-c-dropdown:not(.cat-is-active) .cat-c-dropdown__cross-icon,
.cat-c-dropdown:not(.cat-is-active) .cat-c-dropdown__seperator-line,
.cat-is-readonly .cat-c-dropdown__cross-icon,
.cat-is-readonly .cat-c-dropdown__seperator-line {
  display: none;
}

/**
* Cross icon should be visible when the dropdown is on focus and hover
*/
.cat-c-dropdown__body:hover .cat-c-dropdown__cross-icon,
.cat-c-dropdown__body:hover .cat-c-dropdown__seperator-line, .cat-c-dropdown__body:focus .cat-c-dropdown__cross-icon,
.cat-c-dropdown__body:focus .cat-c-dropdown__seperator-line, .cat-c-dropdown__body:focus-within .cat-c-dropdown__cross-icon,
.cat-c-dropdown__body:focus-within .cat-c-dropdown__seperator-line {
  display: block;
}

.cat-is-error:not(.cat-is-active) .cat-c-dropdown__body {
  border: calc(var(--size-base-unit) * 0.25) solid var(--cat-theme-color-border-utility-error);
}
.cat-is-error:not(.cat-is-active) .cat-c-dropdown__body:focus, .cat-is-error:not(.cat-is-active) .cat-c-dropdown__body:focus-within {
  outline: 2px solid var(--cat-theme-color-focus-ring);
  outline-offset: var(--cat-theme-offset-focus-ring, 2px);
  transition: all var(--cat-anim-fade-quick) var(--cat-anim-ease);
}

/**
 * Dropdown arrow 
 */
.cat-c-dropdown__chevron-down-button,
.cat-c-dropdown__arrow {
  pointer-events: none;
  transition: all var(--cat-anim-fade-quick) var(--cat-anim-ease);
  transform: rotate(0);
  transform-origin: center;
  /**
   * If the dropdown is active, rotate the arrow
   */
}
.cat-is-active .cat-c-dropdown__chevron-down-button,
.cat-is-active .cat-c-dropdown__arrow {
  transform: rotate(180deg);
}
.cat-is-typeahead:not(.cat-is-readonly, .cat-c-dropdown--disabled) .cat-c-dropdown__chevron-down-button,
.cat-is-typeahead:not(.cat-is-readonly, .cat-c-dropdown--disabled) .cat-c-dropdown__arrow {
  pointer-events: auto;
  cursor: pointer;
}

/**
   * If the dropdown is disbaled, change the arrow color
   */
.cat-c-dropdown__arrow {
  --cat-icon-fill: var(--cat-theme-color-content-default);
}
.cat-c-dropdown--disabled .cat-c-dropdown__arrow {
  --cat-icon-fill: var(--cat-theme-color-content-disabled);
}
.cat-is-readonly .cat-c-dropdown__arrow {
  --cat-icon-fill: var(--cat-theme-color-content-disabled);
}

.cat-c-dropdown__skeleton-arrow {
  --cat-icon-fill: var(--cat-theme-color-content-disabled);
  --cat-icon-height: calc(var(--size-base-unit) * 2);
  --cat-icon-width: calc(var(--size-base-unit) * 2);
  position: absolute;
  inset-block-end: var(--cat-space-medium);
  inset-inline-end: var(--cat-space-medium);
  pointer-events: none;
}
.cat-c-dropdown--medium .cat-c-dropdown__skeleton-arrow {
  inset-block-end: var(--cat-space-small);
  inset-inline-end: var(--cat-space-small);
}
.cat-c-dropdown--small .cat-c-dropdown__skeleton-arrow {
  inset-block-end: var(--cat-space-x-small);
  inset-inline-end: var(--cat-space-small);
}

/**
 * Dropdown required
 * 1) If the dropdown is require, then the required label will display
 */
.cat-c-dropdown__notation {
  font-family: var(--cat-theme-typography-footnote-font-family);
  font-weight: var(--cat-theme-typography-footnote-font-weight);
  font-size: var(--cat-theme-typography-footnote-font-size);
  line-height: var(--cat-theme-typography-footnote-line-height);
  margin-inline-end: var(--cat-space-3x-small);
  color: var(--cat-theme-color-content-subtle);
}

/**
 * Dropdown value
 * 1) The selected value of the dropdown
 */
.cat-c-dropdown__before-icon {
  font-family: var(--cat-theme-typography-body-font-family);
  font-weight: var(--cat-theme-typography-body-font-weight);
  font-size: var(--cat-theme-typography-body-font-size);
  line-height: var(--cat-theme-typography-body-line-height);
  order: 1;
  inset-inline-start: var(--cat-dropdown-padding-horiz);
  display: flex;
  align-items: center;
  max-width: calc(100% - var(--size-base-unit) * 6);
  pointer-events: none;
  min-height: calc(var(--size-base-unit) * 3);
  /**
   * Dropdown value within a dropdown that has a value selected
   */
  /**
   * inner text value that shows up when an option is selected.
   */
  /**
   * If the dropdown is disabled, change the color of the value
   */
}
.cat-is-error .cat-c-dropdown__before-icon, .cat-is-warning .cat-c-dropdown__before-icon {
  max-width: calc(100% - var(--size-base-unit) * 10);
}
.cat-c-dropdown--medium .cat-c-dropdown__before-icon {
  inset-inline-start: var(--cat-space-small);
  max-width: calc(100% - var(--size-base-unit) * 6);
}
.cat-c-dropdown--medium.cat-is-warning .cat-c-dropdown__before-icon, .cat-c-dropdown--medium.cat-is-error .cat-c-dropdown__before-icon {
  max-width: calc(100% - var(--size-base-unit) * 9);
}
.cat-c-dropdown--small.cat-is-warning .cat-c-dropdown__before-icon, .cat-c-dropdown--small.cat-is-error .cat-c-dropdown__before-icon {
  max-width: calc(100% - var(--size-base-unit) * 8);
}
.cat-c-dropdown--small .cat-c-dropdown__before-icon {
  inset-inline-start: var(--cat-space-x-small);
  max-width: calc(100% - var(--size-base-unit) * 6);
}
.cat-c-dropdown.cat-has-value .cat-c-dropdown__before-icon {
  font-family: var(--cat-theme-typography-body-font-family);
  font-weight: var(--cat-theme-typography-body-font-weight);
  font-size: var(--cat-theme-typography-body-font-size);
  line-height: var(--cat-theme-typography-body-line-height);
}
.cat-c-dropdown__before-icon .cat-c-dropdown__text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: var(--cat-theme-color-content-default);
}
.cat-has-value .cat-c-dropdown__before-icon .cat-c-dropdown__text, .cat-is-focus .cat-c-dropdown__before-icon .cat-c-dropdown__text, .cat-is-active .cat-c-dropdown__before-icon .cat-c-dropdown__text {
  color: var(--cat-theme-color-content-default);
}
.cat-c-dropdown--disabled .cat-c-dropdown__before-icon .cat-c-dropdown__text {
  color: var(--cat-theme-color-content-disabled);
}
.cat-c-dropdown--disabled .cat-c-dropdown__before-icon {
  color: var(--cat-theme-color-content-disabled);
}

/** 
 * Dropdown value
 * 1) Positions the dropdown panel absolute to the select
 */
.cat-c-dropdown__panel {
  width: 100%;
  z-index: var(--cat-z-index-400);
  display: none;
  /**
   * If the dropdown isDynamicWidth true, then make the dropdown panel adjust to the width of the content
   */
}
.cat-is-dynamic-width .cat-c-dropdown__panel {
  width: max-content;
  min-width: var(--cat-dropdown-width);
}

/**
 * Field note values
 */
cat-field-note {
  /**
  * If the dropdown is hovered, change the color of the foot note value
  */
  /**
  * If the dropdown is disabled, change the color of the foot note value
  */
  /**
  * If the dropdown is active, change the color of the foot note value
  */
}
.cat-c-dropdown:hover cat-field-note {
  --cat-theme-color-content-brand: var(--cat-theme-color-content-default-hover);
}
.cat-c-dropdown.cat-c-dropdown--disabled cat-field-note {
  --cat-theme-color-content-brand: var(--cat-theme-color-content-disabled);
}
.cat-c-dropdown.cat-is-active cat-field-note {
  --cat-theme-color-content-brand: var(--cat-theme-color-content-active);
}

/**
 * Dropdown that displays inline before an input field
 */
.cat-c-dropdown--inline-before .cat-c-dropdown__select {
  border-start-end-radius: 0;
  border-end-end-radius: 0;
  --cat-dropdown-border-start-end-radius: 0;
  --cat-dropdown-border-end-end-radius: 0;
}

/**
 * Dropdown that displays inline after an input field
 */
.cat-c-dropdown--inline-after .cat-c-dropdown__select {
  border-start-start-radius: 0;
  border-end-start-radius: 0;
}

/**
 * Dropdown that shows chip and placeholder/value
 */
.cat-c-dropdown__text-container {
  font-family: var(--cat-theme-typography-body-font-family);
  font-weight: var(--cat-theme-typography-body-font-weight);
  font-size: var(--cat-theme-typography-body-font-size);
  line-height: var(--cat-theme-typography-body-line-height);
  order: 3;
  overflow: hidden;
  display: flex;
  gap: var(--cat-space-x-small);
}
.cat-c-dropdown--small .cat-c-dropdown__text-container {
  align-items: center;
}

.cat-c-dropdown .cat-c-dropdown__text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/**
 * Chip in dropdown
 */
.cat-c-dropdown__chip {
  font-family: var(--cat-theme-typography-body-font-family);
  font-weight: var(--cat-theme-typography-body-font-weight);
  font-size: var(--cat-theme-typography-body-font-size);
  line-height: var(--cat-theme-typography-body-line-height);
  order: 2;
  pointer-events: auto;
  margin-block-end: calc(var(--size-base-unit) * 0.25);
  min-height: calc(var(--size-base-unit) * 2.75);
  /**
  * chip close icon color
  */
  /**
  * Styling border for the chip in readonly state 
  */
}
.cat-c-dropdown--small .cat-c-dropdown__chip {
  margin-block-end: 0;
  display: flex;
}
.cat-c-dropdown__chip::part(close-icon) {
  --cat-icon-fill: var(--cat-theme-color-content-default);
}
.cat-c-dropdown.cat-is-readonly .cat-c-dropdown__chip {
  pointer-events: none;
}
.cat-c-dropdown.cat-is-readonly .cat-c-dropdown__chip::part(close-icon) {
  --cat-icon-fill: var(--cat-theme-color-content-disabled);
}

/**
 * Apply gap between loaders
 */
.cat-c-dropdown--loader {
  display: flex;
  flex-direction: column;
  gap: var(--cat-space-3x-small);
}

.cat-c-dropdown__label-loader {
  margin-block-end: var(--cat-space-3x-small);
}

/**
 * Hide DropdownPanel
 */
.cat-c-dropdown__panel-hide {
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}

/**
 * Inputfield area height in dropdown loader with chevron arrow
 */
.cat-c-dropdown__input-loader {
  --cat-skeleton-loader-height: calc(var(--size-base-unit) * 3);
  position: relative;
  width: 100%;
}
.cat-c-dropdown--medium .cat-c-dropdown__input-loader {
  --cat-skeleton-loader-height: calc(var(--size-base-unit) * 2.5);
}
.cat-c-dropdown--small .cat-c-dropdown__input-loader {
  --cat-skeleton-loader-height: calc(var(--size-base-unit) * 2);
}

/**
 * chevron arrow in dropdown loader
 */
.cat-c-dropdown__skeleton-arrow {
  z-index: 1;
}

.cat-c-dropdown__icon-wrapper {
  order: 4;
  display: flex;
  align-items: center;
}

/*
* Styles for button icon
*/
.cat-c-dropdown__icon {
  margin-inline-end: var(--cat-space-x-small);
}

.cat-c-dropdown__seperator-line {
  width: calc(var(--size-base-unit) * 0.125);
  background: var(--cat-theme-color-border-default);
  height: calc(var(--size-base-unit) * 2);
}

/*
* Set content-disabled color to placeholder/value on focus.
*/
.cat-c-dropdown__input-wrap .cat-c-dropdown__select:focus + .cat-c-dropdown__before-icon .cat-c-dropdown__text {
  color: var(--cat-theme-color-content-default);
}

.cat-c-dropdown:not(.cat-has-before) [part=dropdown-before-icon], .cat-c-dropdown:not(.cat-c-dropdown--has-field-note) .cat-c-dropdown-fieldnote-slot, .cat-c-dropdown:not(.cat-c-dropdown--has-error) .cat-c-dropdown-error-slot, .cat-c-dropdown:not(.cat-c-dropdown--has-warning) .cat-c-dropdown-warning-slot {
  display: none;
}
`;
       